import OrderFoodRequest from '@components/order/models/edit/OrderFoodRequest';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface SideDishListProps {
    orderFood: OrderFoodRequest;
}

const SideDishList: React.FC<SideDishListProps> = observer(({ orderFood }) => {

    let sideDishNamesAndNote: string[] = [];

    if (orderFood.note !== null) {
        sideDishNamesAndNote.push(orderFood.note);
    }

    if (orderFood.sideDish !== undefined && orderFood.sideDish !== null && orderFood.sideDish.length > 0) {
        var sideDishNames = _.map(orderFood.sideDish, (sideDish) => sideDish.name);
        sideDishNamesAndNote.push(...sideDishNames);
    }

    if (sideDishNamesAndNote.length === 0) {
        return null;
    }

    return (
        <Box display={"flex"} flexDirection={"row"}>
            <Typography variant='subtitle2' color={"text.secondary"}>
                {_.join( sideDishNamesAndNote, ',')}
            </Typography>
        </Box>
    )
})

export default SideDishList;